import { render, staticRenderFns } from "./FilterItems.vue?vue&type=template&id=796dbba8&scoped=true"
import script from "./FilterItems.vue?vue&type=script&lang=ts"
export * from "./FilterItems.vue?vue&type=script&lang=ts"
import style0 from "./FilterItems.vue?vue&type=style&index=0&id=796dbba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796dbba8",
  null
  
)

export default component.exports